module.exports = "../../static/img/splash.35d399d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/splash.jpg
// module id = wY26
// module chunks = 2